<!-- 无人机航拍弹框 -->
<template>
  <div class="dialog-UVA">
    <div class="box">
      <div class="left">
        <div class="header">
          <div class="title f-size-24 f-col-white08">无人机巡河</div>
        </div>
        <div class="list">
          <div class="title">无人机巡河列表</div>
          <n-tree ref="layers-manage-tree" block-line cascade checkable :data="listData" key-field="label"
            :default-checked-keys="defaultCheckedKeys" :default-expanded-keys="defaultExpandedKeys"
            :node-props="nodeProps" check-strategy="child" selectable @update:checked-keys="handleCheckedKeysChange" />
        </div>
        <div class="info">
          <div class="title">航飞基本信息</div>
          <div class="content">
            <p class="title">飞行时间：</p>
            <p>{{ details.createTime }}</p>
            <p class="title">飞行里程：</p>
            <p>{{ details.distance }}km</p>
            <p class="title">任务描述：</p>
            <p>{{ details.description }}</p>
          </div>
        </div>
      </div>
      <div class="content">
        <div v-if="details.videoUrl" class="video-box">
          <div class="title">航飞视频</div>
          <div class="video">
            <video ref="video" controls class="video video-js vjs-default-skin vjs-big-play-centered"></video>
          </div>
        </div>
        <!-- <div v-else class="video-box">暂无视频</div> -->
        <div class="map-box">
          <div class="tabs">
            <div class="tab-pane" :class="tabKey == '航飞轨迹' ? 'active' : ''" @click="tabKey = '航飞轨迹'">
              航飞轨迹
            </div>
            <div class="tab-pane" :class="tabKey == '光谱反演' ? 'active' : ''" @click="tabKey = '光谱反演'">
              光谱反演
            </div>
            <div v-show="warning" class="tab-pane" :class="tabKey == '卫星对照' ? 'active' : ''" @click="tabKey = '卫星对照'">
              卫星对照
            </div>
          </div>
          <div v-show="details" class="content">
            <div v-if="details" id="hfgj" class="hfgj" :style="details.id == 3 ? 'width: 150rem' : 'width: 60rem'">
            </div>
            <div class="gpfy" :class="tabKey == '光谱反演' ? 'active' : ''" :style="details.id == 3 ? 'width: 150rem' : ''">
              <div class="mask"></div>
              <div v-show="details.id == 4">
                <img src="../../assets/img/gmsyzs.jpg" />
                <img src="../../assets/img/adhl.jpg" />
              </div>
              <div v-show="details.id == 2" id="gpfy-ad" ref="gpfyAD">
                <div class="legend">
                  <h6>氨氮含量</h6>
                  <p><span class="color"></span><span>Ⅰ,Ⅱ类</span></p>
                  <p><span class="color"></span><span>Ⅲ类</span></p>
                  <p><span class="color"></span><span>Ⅳ类</span></p>
                  <p><span class="color"></span><span>Ⅴ类</span></p>
                  <p><span class="color"></span><span>劣Ⅴ类</span></p>
                </div>
              </div>
              <div v-show="details.id == 2" id="gpfy-zl" ref="gpfyZL">
                <div class="legend">
                  <h6>总磷含量</h6>
                  <p><span class="color"></span><span>Ⅰ,Ⅱ类</span></p>
                  <p><span class="color"></span><span>Ⅲ类</span></p>
                  <p><span class="color"></span><span>Ⅳ类</span></p>
                  <p><span class="color"></span><span>Ⅴ类</span></p>
                  <p><span class="color"></span><span>劣Ⅴ类</span></p>
                </div>
              </div>
              <div v-show="details.id == 3" id="gpfy-ad-ljx" ref="gpfyADljx">
                <div class="legend">
                  <h6>氨氮含量</h6>
                  <p><span class="color"></span><span>Ⅰ,Ⅱ类</span></p>
                  <p><span class="color"></span><span>Ⅲ类</span></p>
                  <p><span class="color"></span><span>Ⅳ类</span></p>
                  <p><span class="color"></span><span>Ⅴ类</span></p>
                  <p><span class="color"></span><span>劣Ⅴ类</span></p>
                </div>
              </div>
              <div v-show="details.id == 3" id="gpfy-zl-ljx" ref="gpfyZLljx">
                <div class="legend">
                  <h6>总磷含量</h6>
                  <p><span class="color"></span><span>Ⅰ,Ⅱ类</span></p>
                  <p><span class="color"></span><span>Ⅲ类</span></p>
                  <p><span class="color"></span><span>Ⅳ类</span></p>
                  <p><span class="color"></span><span>Ⅴ类</span></p>
                  <p><span class="color"></span><span>劣Ⅴ类</span></p>
                </div>
              </div>
              <div v-show="details.id == 3" id="gpfy-gmsj-ljx" ref="gpfyGMSJljx">
                <div class="legend">
                  <h6>高锰酸钾含量</h6>
                  <p><span class="color"></span><span>Ⅰ,Ⅱ类</span></p>
                  <p><span class="color"></span><span>Ⅲ类</span></p>
                  <p><span class="color"></span><span>Ⅳ类</span></p>
                  <p><span class="color"></span><span>Ⅴ类</span></p>
                  <p><span class="color"></span><span>劣Ⅴ类</span></p>
                </div>
              </div>
              <div v-show="details.id == 3" id="gpfy-hcst-ljx" ref="gpfyHCSTljx">
                <div class="legend">
                  <h6>黑臭水体含量</h6>
                  <p><span class="color"></span><span>正常水体</span></p>
                  <p><span class="color"></span><span>轻度黑臭</span></p>
                  <p><span class="color"></span><span>中度黑臭</span></p>
                  <p>
                    <span class="color" style="background: #f22d2d"></span><span>重度黑臭</span>
                  </p>
                </div>
              </div>
              <div v-show="details.id == 3" id="gpfy-sh-ljx" ref="gpfySHljx">
                <div class="legend">
                  <h6>水华</h6>
                  <p><span class="color"></span><span>无水华</span></p>
                  <p><span class="color"></span><span>无明显水华</span></p>
                  <p><span class="color"></span><span>轻度水华</span></p>
                  <p><span class="color"></span><span>中度水华</span></p>
                  <p><span class="color"></span><span>重度水华</span></p>
                </div>
              </div>
            </div>
            <div v-show="tabKey == '卫星对照'">
              <div class="mask"></div>
              <div class="wxdz"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, markRaw, onMounted, onBeforeUnmount } from 'vue'
import { ref } from 'vue'
import Bus from '@/config/Bus'
import { THREE } from 'threebox-plugin'
import { MapService } from '@/utils/mapServices2'
import Video from 'video.js'
import { Api, LyQuery } from '@/api/publicApi'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'

const api = new Api()
const mainStore = useMainStore(pinia)
const mapService2 = new MapService()
const mapServiceAD = new MapService()
const mapServiceZL = new MapService()
const mapServiceADljx = new MapService()
const mapServiceZLljx = new MapService()
const mapServiceHCSTljx = new MapService()
const mapServiceSHljx = new MapService()
const mapServiceGMSJljx = new MapService()
const props = defineProps({
  data: Object,
})

const defaultExpandedKeys = ref<string[]>([])
const gpfyAD = ref()
const gpfyZL = ref()
const warning = ref(false)
const playState = ref(false)
const mapState = ref(false)
const tabKey = ref('航飞轨迹')
const timer = ref()
const changTimeInt = ref()
const listData = ref([
  {
    label: '九龙河',
    children: [
      {
        label: '飞行视频1',
      },
    ],
  },
])
const details = ref({})
const pointsV3 = ref([])
const video = ref()
let player: {
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}

const getWrjFlightDetailByIdUsingGET = () => {
  api.screen.getWrjFlightDetailByIdUsingGet({ id: props.data.id }).then((res) => {
    if (res.code === 200) {
      details.value = res.data || {}
      listData.value = [
        {
          label: res.data?.ly || '',
          children: [],
        },
      ]
      setTimeout(() => {
        initMap()
        getVideo()
      }, 1000)
    }
  })
}
const initMap = () => {
  mapService2.initMap(
    {
      container: 'hfgj',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/ht新河长大屏-详情.json',
      center: [105.86517773950351, 29.297694887532586],
      zoom: 15,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapService2.map.once('styledata', () => {
    mapState.value = true
    mapService2.flyTo({
      center: [parseFloat(details.value.startJd), parseFloat(details.value.startWd)],
    })
    mapService2.addPointLayer(
      'UAVPoint',
      [parseFloat(details.value.startJd), parseFloat(details.value.startWd)],
      '',
      'UAV.png',
      0.9,
      'center'
    )
    // getPoint()
    flightTrajectory()
  })
}

const getVideo = () => {
  if (details.value.videoUrl) {
    const option = {
      muted: false,
      // controls: true,
      loop: false,
      autoplay: false,
      sources: [
        {
          type: 'video/mp4',
          src: details.value.videoUrl, // url地址
          // src: 'https://xcx.ljh.cqhtwl.com.cn/files/wrj-fly/dji_export_164932067523%E5%BE%B7%E8%83%9C%E6%A1%A5%E5%88%B0%E7%9F%AE%E5%A2%A9%E6%A1%A5.mp4', // url地址
        },
      ],
      notSupportedMessage: '此视频暂无法播放，请稍后再试',
      // poster:,
      // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
    }
    // 初始化的时候标签默认都是显示的
    player = Video(video.value, option, () => {
      // this.play();
      player.on('error', () => {
        player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
        console.log('视频加载错误')
        let time = 0
        changTimeInt.value = setInterval(() => {
          changTime(time)
          time++
          if (time > 600) {
            time = 0
          }
        }, 100)
      })
      player.on('pause', () => {
        playState.value = false
        clearInterval(timer.value)
      })
      player.on('timeupdate', changTime)
    })
    playState.value = true
    flightTrajectory()
    player.play().then(() => {
      player.on('play', () => {
        playState.value = true
      })
      playState.value = true
      flightTrajectory()
    })
  } else {
    playState.value = true
    flightTrajectory()
    let time = 0
    changTimeInt.value = setInterval(() => {
      changTime(time)
      time++
      if (time > 600) {
        time = 0
      }
    }, 100)
  }
}

// 渲染轨迹
const flightTrajectory = () => {
  if (playState.value && mapState.value) {
    let duration = player ? player.duration() : 600
    duration ? '' : (duration = 600)
    /* eslint-disable */
    // const trajectory = [
    //   [105.86517773950351, 29.297694887532586],
    //   [105.89617773950351, 29.297694887532586],
    //   [105.89617773950351, 29.250694887532586],
    // ];
    const trajectory = JSON.parse(details.value.flightpath)
    const myArray = []
    for (let i = 0; i < trajectory.length; i += 1) {
      myArray.push(new THREE.Vector3(trajectory[i][0], trajectory[i][1], 0))
    }
    const curve = new THREE.CatmullRomCurve3(myArray)
    pointsV3.value = curve.getPoints(duration * 20)
    const newLine = []
    for (let i = 0; i < pointsV3.value.length; i += 1) {
      newLine.push([pointsV3.value[i].x, pointsV3.value[i].y])
    }
    mapService2.drawTrajectory('trajectory', newLine, '', 6, 'UAVPoint')
    // const line = turf.lineString(trajectory);
    // const chunk = turf.lineChunk(line, 0.01, { units: 'miles' });
    // const sample = turf.sample(chunk, 5);
    // console.log(chunk);
    // console.log(sample);
    // const sample = turf.sample(
    //   {
    //     type: 'FeatureCollection',
    //     features: [
    //       {
    //         type: 'Feature',
    //         geometry: {
    //           type: 'LineString',
    //           coordinates: trajectory,
    //         },
    //       },
    //     ],
    //   },
    //   5,
    // );
    // let i = 0;
    // this.timer = setInterval(() => {
    //   const data = {
    //     type: 'FeatureCollection',
    //     features: [
    //       {
    //         type: 'Feature',
    //         geometry: {
    //           type: 'Point',
    //           coordinates: [this.pointsV3[i].x, this.pointsV3[i].y],
    //         },
    //       },
    //     ],
    //   };
    //   mapService2.map.getSource('UAVPoint').setData(data);
    //   if (i < this.pointsV3.length - 1) {
    //     i += 1;
    //     // console.log(i);
    //   } else {
    //     i = 0;
    //     console.log(this.timer);
    //     clearInterval(this.timer);
    //   }
    // }, 10);
  }
}

function changTime(_time: number) {
  let index: number
  if (typeof _time == 'number') {
    index = parseInt(_time * 20, 10)
  } else {
    index = parseInt(player.currentTime() * 20, 10)
  }
  if (timer.value) {
    clearInterval(timer.value)
  }
  if (playState.value) {
    timer.value = setInterval(() => {
      const data = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [pointsV3.value[index].x, pointsV3.value[index].y],
            },
          },
        ],
      }
      index += 1
      mapService2.map.getSource('UAVPoint').setData(data)
    }, 50)
  } else {
    const data = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [pointsV3.value[index].x, pointsV3.value[index].y],
          },
        },
      ],
    }
    index += 1
    mapService2.map.getSource('UAVPoint').setData(data)
  }
}

//光谱反演
const initMapGPFW = () => {
  let legendAD = gpfyAD.value.getElementsByClassName('legend')[0]
  let legendZL = gpfyZL.value.getElementsByClassName('legend')[0]
  gpfyAD.value.innerHTML = ''
  gpfyZL.value.innerHTML = ''
  gpfyAD.value.appendChild(legendAD)
  gpfyZL.value.appendChild(legendZL)
  mapServiceAD.initMap(
    {
      container: 'gpfy-ad',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06252, 29.40677],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceAD.map.once('styledata', () => {
    mapServiceAD.showLayer('szfy-ad')
  })
  mapServiceZL.initMap(
    {
      container: 'gpfy-zl',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06252, 29.40677],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceZL.map.once('styledata', () => {
    mapServiceZL.showLayer('szfy-zl')
  })

  mapServiceZLljx.initMap(
    {
      container: 'gpfy-zl-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceZLljx.map.once('styledata', () => {
    mapServiceZLljx.showLayer('ljx_zl总磷')
  })
  mapServiceADljx.initMap(
    {
      container: 'gpfy-ad-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceADljx.map.once('styledata', () => {
    mapServiceADljx.showLayer('ljx_ad氨氮')
  })
  mapServiceHCSTljx.initMap(
    {
      container: 'gpfy-hcst-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceHCSTljx.map.once('styledata', () => {
    mapServiceHCSTljx.showLayer('ljx_boi黑臭水体')
  })
  mapServiceSHljx.initMap(
    {
      container: 'gpfy-sh-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceSHljx.map.once('styledata', () => {
    mapServiceSHljx.showLayer('ljx_rvi水华')
  })
  mapServiceGMSJljx.initMap(
    {
      container: 'gpfy-gmsj-ljx',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/szfy新.json',
      center: [106.06452, 29.39377],
      zoom: 13.9,
      minZoom: 10.5,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  mapServiceGMSJljx.map.once('styledata', () => {
    mapServiceGMSJljx.showLayer('ljx_gmsj高锰酸钾')
  })
}

const nodeProps = ({ option }: { option: any }) => {
  return {
    onClick(n: { path: { className: string }[] }) {
      if (option.children) {
        if (n.path[0].className !== 'n-checkbox-box__border') {
          if (defaultExpandedKeys.value.indexOf(option.label) == -1) {
            defaultExpandedKeys.value.push(option.label)
          } else {
            defaultExpandedKeys.value.splice(defaultExpandedKeys.value.indexOf(option.label), 1)
          }
        }
      }
    },
  }
}

const getPoint = () => {
  const params: LyQuery = {
    ly: '永川全区域',
  }
  api.screen.getGyqyPointUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '工业企业')
    }
  })
  api.screen.getGyyqPointUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '工业园区')
    }
  })
  api.screen.wsclcStatisticsClickPointUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '污水处理厂')
    }
  })
  api.screen.getNmscListUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '农贸市场')
    }
  })
  api.screen.getCyqyListUsingPost().then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '餐饮企业')
    }
  })
  api.screen.getXqyzListUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '畜牧养殖', '畜禽养殖场')
    }
  })
  api.screen.getScyzListUsingPost(params).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '水产养殖', '水产养殖场')
    }
  })
  api.screen.getBasicClickPointListUsingPost({ ...params, no: 8000 }).then((res) => {
    if (res.code == 200) {
      showLayer(res.data, '沿河排口')
    }
  })
}

const showLayer = (data: string | any[] | undefined, type: string, icon: string | undefined) => {
  let pointList = []
  for (let i = 0; i < data.length; i++) {
    switch (data[i].category) {
      case '雨水排口':
        icon = '雨水排口'
        break
      case '污水排口':
        icon = '污水排口'
        break
      case '雨污混排':
        icon = '雨污排口'
      default:
    }
    let properties = { ...data[i], modalType: type, icon: icon ? `${icon}.png` : `${type}.png` }
    if (properties.psName) {
      properties.name = properties.psName
    }
    if (properties.mc) {
      properties.name = properties.mc
    }
    if (properties.qymc) {
      properties.name = properties.qymc
    }
    pointList.push({
      coordinates: [
        data[i].jd
          ? parseFloat(data[i].jd)
          : data[i].lon
            ? parseFloat(data[i].lon)
            : parseFloat(data[i].Longitude),
        data[i].wd
          ? parseFloat(data[i].wd)
          : data[i].lat
            ? parseFloat(data[i].lat)
            : parseFloat(data[i].Latitude),
      ],
      properties: properties,
    })
  }
  mapServiceAD.addPointsLayer(type, pointList, '', 0.8, 'bottom', true)
  mapServiceZL.addPointsLayer(type, pointList, '', 0.8, 'bottom', true)
}

onMounted(() => {
  initMapGPFW()
  getWrjFlightDetailByIdUsingGET()
})

onBeforeUnmount(() => {
  if (timer.value) {
    clearInterval(timer.value)
  }
  if (changTimeInt.value) {
    clearInterval(changTimeInt.value)
  }
  mapService2.map.remove()
  mapServiceAD.map.remove()
  mapServiceZL.map.remove()
  mapServiceADljx.map.remove()
  mapServiceZLljx.map.remove()
  mapServiceHCSTljx.map.remove()
  mapServiceSHljx.map.remove()
  mapServiceGMSJljx.map.remove()
  player.off('timeupdate', changTime)
})
</script>

<style lang="scss" scoped>
.dialog-UVA {
  height: 61.8rem;
  width: 173rem;
  color: #ffffff;

  &>.box {
    height: 65.9rem;
    width: 178rem;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;

    .left {
      width: 21rem;
      height: calc(100% - 3rem);
      padding: 1.5rem;

      :deep(.n-tree) {
        text-align: left;

        .n-tree-node--selectable {
          background: #ffffff00 !important;

          &:hover {
            background: #ffffff17 !important;
          }
        }

        .n-tree-node-switcher {
          -webkit-pointer-events: none;
          -moz-pointer-events: none;
          -ms-pointer-events: none;
          -o-pointer-events: none;
          pointer-events: none;
        }

        .n-tree-node-content {
          padding-right: 0;
        }

        .n-checkbox {
          --n-border-checked: 1px solid #29cee0 !important;
          --n-border-focus: 1px solid #29cee0 !important;
          --n-box-shadow-focus: 0 0 0 2px #00a9ff5c !important;
          --n-color-checked: #29cee0 !important;

          &.n-checkbox--checked,
          &.n-checkbox--indeterminate {
            .n-checkbox-box {
              background: #0086e8;

              .line-icon,
              .check-icon {
                fill: #ffffff;
              }
            }
          }
        }
      }

      .header {
        padding: 0.5rem 0 2rem 1rem;

        .title {
          line-height: 3.5rem;
          text-align: left;
        }
      }

      .list {
        border-bottom: 1px solid #ffffff4d;
        margin: 1rem 0.5rem 1rem 1rem;
        height: calc(50% - 8rem);

        .title {
          font-size: 1.5rem;
          padding: 0.5rem;
          color: #8aedf2;
          border: 1px solid #8aedf2;
          text-align: center;
        }

        .el-tree {
          color: #90dccad9;
          background-color: unset;
          height: 15rem;
          overflow: auto;
          margin: 1rem 0;

          :v-deep(.el-tree-node) {
            .el-tree-node__content {
              height: 2.3rem;
              margin-bottom: 0.3rem;
              background: #344e5c80;

              &:hover {
                background: #344e5c80;
              }

              .el-checkbox {
                .el-checkbox__input {
                  .el-checkbox__inner {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 0;
                    position: static;
                    width: 1rem;
                    height: 1rem;
                    left: 0;
                    top: calc(50% - 0.8rem / 2);
                    background: #ffffff;
                    border-radius: 0.1rem;
                    flex: none;
                    order: 0;
                    flex-grow: 0;
                    margin-right: 0.6rem;

                    &::after {
                      left: 0.4rem;
                      border-width: 0.1rem;
                      border-color: #ffffff;
                      height: 0.35rem;
                      top: 0.25rem;
                      width: 0.15rem;
                    }
                  }

                  &.is-indeterminate {
                    .el-checkbox__inner {
                      background: #90dccad9;

                      &::before {
                        background-color: #ffffff;
                        height: 0.2rem;
                        left: 0.1rem;
                        right: 0;
                        top: 0.35rem;
                        width: 0.9rem;
                      }
                    }
                  }

                  &.is-checked {
                    .el-checkbox__inner {
                      background: #90dccad9;
                    }
                  }
                }
              }

              .el-tree-node__label {
                font-size: 1.4rem;
                line-height: 1.1rem;
              }
            }
          }
        }
      }

      .info {
        margin: 1rem 0.5rem 1rem 1rem;

        &>.title {
          font-size: 1.5rem;
          text-align: left;
          padding: 1.5rem 0 0.5rem 0;
        }

        &>.content {
          height: 26rem;
          overflow: auto;

          p {
            font-size: 1.3rem;
            text-align: left;
            margin: 0.9rem 0;
            color: #ffffff;
          }

          .title {
            color: #b0feff;
          }
        }
      }
    }

    &>.content {
      text-align: left;
      flex: 1;
      display: flex;
      padding: 7.5rem 2rem 2.5rem 2rem;

      .video-box {
        flex: 3;
        display: flex;
        flex-direction: column;
        margin-right: 1.4rem;

        .title {
          font-size: 1.8rem;
          padding: 1.8rem 0 1.5rem 0;
        }

        .video {
          flex: 1;

          video {
            width: 100%;
            height: 100%;
          }

          &>div {
            width: 100%;
            height: 100%;
          }
        }
      }

      .map-box {
        flex: 2;
        display: flex;
        flex-direction: column;

        .tabs {
          color: #aae2ff;
          padding: 1.8rem 0 1.5rem 0;

          .tab-pane {
            font-size: 1.4rem;
            display: inline-block;
            margin-right: 1.5rem;
            cursor: pointer;
          }

          .active {
            color: #ffffff;
          }
        }

        .content {
          flex: 1;
          background: #90dcca;
          position: relative;

          :v-deep(.mapboxgl-canvas-container) {
            width: 100%;
            height: 100%;
          }

          .gpfy {
            z-index: -1;
            width: 60rem;
            height: 50.7rem;

            h6 {
              margin: 1rem;
            }

            #gpfy-zl {
              width: 30rem;
              height: 50.7rem;
              left: 0%;
              top: 0%;
            }

            #gpfy-ad {
              width: 30rem;
              height: 50.7rem;
              left: 50%;
              top: 0%;
            }

            #gpfy-zl-ljx {
              width: 30rem;
              height: 50.7rem;
              left: 0%;
              top: 0%;
            }

            #gpfy-ad-ljx {
              width: 30rem;
              height: 50.7rem;
              left: 20%;
              top: 0%;
            }

            #gpfy-gmsj-ljx {
              width: 30rem;
              height: 50.7rem;
              left: 40%;
              top: 0%;
            }

            #gpfy-hcst-ljx {
              width: 30rem;
              height: 50.7rem;
              left: 60%;
              top: 0%;
            }

            #gpfy-sh-ljx {
              width: 30rem;
              height: 50.7rem;
              left: 80%;
              top: 0%;
            }

            .legend {
              color: #ffffff;
              position: absolute;
              z-index: 1;
              left: 0;
              bottom: 0.4rem;
              font-size: 1.2rem;
              line-height: 2rem;

              p {
                display: flex;
                align-items: center;
                margin: 0px 10px;

                &:nth-child(2) .color {
                  background: #3693fc;
                }

                &:nth-child(3) .color {
                  background: #42f8a1;
                }

                &:nth-child(4) .color {
                  background: #f8d93e;
                }

                &:nth-child(5) .color {
                  background: #faa62b;
                }

                &:nth-child(6) .color {
                  background: #f22d2d;
                }

                .color {
                  display: inline-block;
                  width: 1rem;
                  height: 2rem;
                  margin-right: 0.5rem;
                }
              }
            }
          }

          .active {
            z-index: 0;
          }

          &>div {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;

            &>div {
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              position: absolute;
            }
          }

          .mask {
            background: rgba(1, 89, 158, 1);
          }

          img {
            width: 300px;
            height: 506px;
          }
        }
      }
    }
  }
}
</style>
